export class ValueUtils {
    public static toSelectValue(value?: string | number | null): string | null {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        return String(value);
    }

    public static toNumber(value: unknown): number | null {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        const numberValue = Number(value);
        return Number.isNaN(numberValue) ? null : numberValue;
    }

    public static toDecimal(value: unknown): number | null {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        return typeof value === 'number' ? value : Number(value);
    }

    public static normalizeText(value: unknown): string | null {
        const text = String(value ?? '').trim();
        return text ? text : null;
    }
}
